export default {
  priceChanged: 'This has changed the price to:',
  changeAnswer: 'Change Answer',
};
